import React from 'react'

export default function Box3() {
    return (
        <div className='w-100 col-4'>
             <div className="custom-roadmap-box-container p-3 rounded-3">
                      <h1>Advanced Analytics and Reporting Tools</h1>
                      <hr/>
                      <p>Continuing our commitment to innovation, we introduced advanced analytics and reporting tools, empowering users to make data-driven decisions and optimize performance.</p>
                      
                    </div>
        </div>
      )
}
